// extracted by mini-css-extract-plugin
module.exports = {"Container":"MainView_Container__OCjYb","BackgroundCover":"MainView_BackgroundCover__Gqbe5","BackgroundImage":"MainView_BackgroundImage__dnYHt"};